module.exports = __webpack_public_path__ + "img/location.472dca6a.svg";